const taskmaster = [
	{
		'description': 'Buzz asset "{{$worker.getName}}"',
		'event': 'buzz',
		'rec': ['workers'],
		'arg': {'workers': {}},
		'entry': 'rec.workers.id'
	},
	{
		'description': 'Call a muster',
		'watch': 'muster',
		'value': 1
	},
	{
		'description': 'Enter percentage of time in work zone for project day {{random_day}}',
		'type': 'input',
		'data_type': 'number',
		'data': 'report.zone_time.work',
		'entry': 'random_day',
		'auth': 'project'
	},
	{
		'description': 'Who fell from height on {{rec.alert.clock}}?',
		'rec': ['alert'],
		'arg': {
			'alert': {type: 'fall'}
		},
		'type': 'input',
		'data_type': 'string',
		'entry': ['rec.alert.worker.first_name+rec.alert.worker.last_name', 'rec.alert.worker.badge_number'],
		'auth': 'project'

	},
	{
		'description': 'What zone was asset "{{$worker.getName}}" in on {{rec.watcher.clock}}',
		'rec': ['workers','watcher','zones'],
		'arg': {
			'zones': {'id': 'rec.watcher.zone_id'}
		},
		'type': 'input',
		'data_type': 'string',
		'entry': 'rec.zones.name',
		'auth': 'profile-panel'
	},
	{
		'description': 'What company does asset "{{$worker.getName}}" work for?',
		'rec': ['workers'],
		'type': 'input',
		'data_type': 'string',
		'entry': 'rec.workers.company.title'
	},
	{
		'description': 'Locate asset "{{$worker.getName}}" on the map',
		'event': 'find',
		'rec': ['workers'],
		'entry': 'rec.workers.id'
	}

];

export default taskmaster;
